import { render, staticRenderFns } from "./buildInfo.vue?vue&type=template&id=cc263e3a&scoped=true"
import script from "./buildInfo.vue?vue&type=script&lang=js"
export * from "./buildInfo.vue?vue&type=script&lang=js"
import style0 from "./buildInfo.vue?vue&type=style&index=0&id=cc263e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc263e3a",
  null
  
)

export default component.exports